import styled, { css } from 'styled-components'

import { icons } from '@/constants/icons'

export const HeaderContainer = styled.div`
  height: 200px;
  position: relative;
  display: flex;
  margin-right: 112px;
  align-items: center;
`

export const HeaderElem = styled.div`
  position: relative;
  display: flex;
  flex: 0 1 auto;
  height: 100px;
  overflow: hidden;
`
export const HeaderLabels = styled.div`
  position: relative;
  display: flex;
  height: 100px;
  flex: 1 0 auto;
  align-items: center;
  justify-content: flex-end;
  padding-left: 20px;
`

export const LogoBox = styled.div<{ $hasSecondLogo?: boolean }>`
  height: 100px;
  width: auto;
  flex-shrink: 0;
  margin-right: ${({ $hasSecondLogo }) => ($hasSecondLogo ? '0' : '24px')};
`

export const PageLogo = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  max-width: 220px;
  max-height: 100%;
`

export const HeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;
`

export const SmallHeaderText = styled.div`
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 22px;
  line-height: 1.1;
  color: ${(props) => props.theme.colors.pageHeader.text};
  text-transform: uppercase;
`

export const PageName = styled.div`
  font-weight: 500;
  font-size: 60px;
  line-height: 1.1;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.pageHeader.title};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FavWrapper = styled.div<{
  $hidden: boolean
  $isLoading: boolean
  $isFavoritePage: boolean
}>`
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  width: ${({ $hidden }) => ($hidden ? 0 : 'auto')};
  background: ${(props) => props.theme.colors.pageHeader.favorite.background};
  border-radius: 50%;
  overflow: hidden;
  margin-left: ${({ $hidden }) => ($hidden ? 0 : '16px')};

  & button {
    opacity: 1;
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }
  & button > img {
    width: 34px;
    height: 30px;
  }

  ${({ $isLoading, $isFavoritePage }) =>
    $isLoading &&
    css`
      & button img {
        mask-image: url(${icons.favorites.heart});
        mask-size: 34px 30px;
        mask-repeat: no-repeat;
        mask-position: center;
        background: ${(props) =>
            `linear-gradient(to top, ${props.theme.colors.text} 50%, transparent 50%,  transparent 100%)`},
          url(${icons.favorites.heart});
        background-size: 100% 200%, 0 0;
        animation: loading 2s infinite ${$isFavoritePage ? 'reverse' : 'normal'};
      }
    `}

  @keyframes loading {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 0 100%;
    }
  }
`
export const PromotionTokens = styled.div`
  display: flex;
  align-items: center;
  font-size: 20px;
  height: 64px;
  line-height: 64px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.text};
  padding: 0 20px;
  border-radius: 32px;
  border: 2px solid ${(props) => props.theme.colors.text};

  img {
    height: 32px;
    width: 32px;
    object-fit: contain;
    margin-left: 8px;
  }
`
export const PromotionLabel = styled.div`
  white-space: nowrap;
  text-transform: uppercase;
`
